import { post, get } from '@/utils/http'

export function getTrustData (params) {
  return post({ url: '/service-insight/finance_trust/get_trust_data', params })
}
export function getDetail (params) {
  return get({ url: '/service-insight/finance_trust/trust_detail', params })
}